import { render, staticRenderFns } from "./mode-title-img.vue?vue&type=template&id=2a21e40e&scoped=true"
import script from "./mode-title-img.vue?vue&type=script&lang=js"
export * from "./mode-title-img.vue?vue&type=script&lang=js"
import style0 from "./mode-title-img.vue?vue&type=style&index=0&id=2a21e40e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21e40e",
  null
  
)

export default component.exports